<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <ConsultarUnimed style="height: 100%;"/>
    </div>
</template>

<script>
import ConsultarUnimed from '../components/ConsultarUnimed/ConsultarUnimed'

export default {
  components: {
    ConsultarUnimed
  }
}
</script>
